import React from "react";
import { FormattedMessage, MessageDescriptor } from "react-intl";
import { ErrorField } from "../../EditExtra/styles";

export type ErrorFieldMessageProps = MessageDescriptor & { values?:{ [key: string]: any }};

export function ErrorFieldMessage(props: ErrorFieldMessageProps) {
  return (
    <ErrorField>
      <FormattedMessage {...props} />
    </ErrorField>
  );
}